import * as React from 'react';

type Props = {
  children: React.ReactNode;
  maxHeight?: number | string;
};

export const ClubProgrammeDataTableShell: React.FC<Props> = ({ children, maxHeight = 'calc(100vh - 420px)' }) => {
  return (
    <div className="cpDataTableShell">
      <div className="cpDataTableShellScroll" style={{ maxHeight }}>
        {children}
      </div>
    </div>
  );
};
